var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3484_5166",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 19L11.5 17.5L16 13L20.5 17.5L19 19L16 16L13 19Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.5L9.37868 15.3787L7.25736 17.5L9.37868 19.6213L11.5 17.5ZM13 19L10.8787 21.1213L13 23.2426L15.1213 21.1213L13 19ZM16 16L18.1213 13.8787L16 11.7574L13.8787 13.8787L16 16ZM19 19L16.8787 21.1213L19 23.2426L21.1213 21.1213L19 19ZM20.5 17.5L22.6213 19.6213L24.7426 17.5L22.6213 15.3787L20.5 17.5ZM16 13L18.1213 10.8787L16 8.75736L13.8787 10.8787L16 13ZM9.37868 19.6213L10.8787 21.1213L15.1213 16.8787L13.6213 15.3787L9.37868 19.6213ZM15.1213 21.1213L18.1213 18.1213L13.8787 13.8787L10.8787 16.8787L15.1213 21.1213ZM13.8787 18.1213L16.8787 21.1213L21.1213 16.8787L18.1213 13.8787L13.8787 18.1213ZM21.1213 21.1213L22.6213 19.6213L18.3787 15.3787L16.8787 16.8787L21.1213 21.1213ZM22.6213 15.3787L18.1213 10.8787L13.8787 15.1213L18.3787 19.6213L22.6213 15.3787ZM13.8787 10.8787L9.37868 15.3787L13.6213 19.6213L18.1213 15.1213L13.8787 10.8787Z",
    fill: "inherit",
    mask: "url(#path-2-inside-1_3484_5166)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.853c570d68383466a72826c70eac3c3c.svg";
export { ForwardRef as ReactComponent };